import React from 'react';
import { FacebookIcon, InstagramIcon, TwitterIcon, MailIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function Footer() {
  return <footer className="w-full bg-blue-900 text-white" data-id="element-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-51">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12" data-id="element-52">
          {/* Empresa */}
          <div data-id="element-53">
            <h3 className="text-xl font-bold mb-4" data-id="element-54">Empresa</h3>
            <ul className="space-y-3" data-id="element-55">
              <li data-id="element-56">
                <a href="#nosotros" className="text-blue-100 hover:text-white transition-colors" data-id="element-57">
                  Sobre nosotros
                </a>
              </li>
              <li data-id="element-58">
                <a href="#mision" className="text-blue-100 hover:text-white transition-colors" data-id="element-59">
                  Nuestra misión
                </a>
              </li>
              <li data-id="element-60">
                <a href="#equipo" className="text-blue-100 hover:text-white transition-colors" data-id="element-61">
                  Equipo
                </a>
              </li>
              <li data-id="element-62">
                <a href="#carreras" className="text-blue-100 hover:text-white transition-colors" data-id="element-63">
                  Carreras
                </a>
              </li>
            </ul>
          </div>

          {/* Servicios */}
          <div data-id="element-64">
            <h3 className="text-xl font-bold mb-4" data-id="element-65">Servicios</h3>
            <ul className="space-y-3" data-id="element-66">
              <li data-id="element-67">
                <a href="#vuelos" className="text-blue-100 hover:text-white transition-colors" data-id="element-68">
                  Vuelos
                </a>
              </li>
              <li data-id="element-69">
                <a href="#remesas" className="text-blue-100 hover:text-white transition-colors" data-id="element-70">
                  Remesas
                </a>
              </li>
              <li data-id="element-71">
                <a href="#recargas" className="text-blue-100 hover:text-white transition-colors" data-id="element-72">
                  Recargas
                </a>
              </li>
              <li data-id="element-73">
                <a href="#combos" className="text-blue-100 hover:text-white transition-colors" data-id="element-74">
                  Combos de comida
                </a>
              </li>
              <li data-id="element-75">
                <a href="#envios" className="text-blue-100 hover:text-white transition-colors" data-id="element-76">
                  Envíos
                </a>
              </li>
            </ul>
          </div>

          {/* Categorías */}
          <div data-id="element-77">
            <h3 className="text-xl font-bold mb-4" data-id="element-78">Categorías</h3>
            <ul className="space-y-3" data-id="element-79">
              <li data-id="element-80">
                <a href="#tecnologia" className="text-blue-100 hover:text-white transition-colors" data-id="element-81">
                  Tecnología
                </a>
              </li>
              <li data-id="element-82">
                <a href="#hogar" className="text-blue-100 hover:text-white transition-colors" data-id="element-83">
                  Hogar
                </a>
              </li>
              <li data-id="element-84">
                <a href="#cocina" className="text-blue-100 hover:text-white transition-colors" data-id="element-85">
                  Cocina
                </a>
              </li>
              <li data-id="element-86">
                <a href="#moda" className="text-blue-100 hover:text-white transition-colors" data-id="element-87">
                  Moda
                </a>
              </li>
            </ul>
          </div>

          {/* Contacto */}
          <div data-id="element-88">
            <h3 className="text-xl font-bold mb-4" data-id="element-89">Contacto</h3>
            <ul className="space-y-3" data-id="element-90">
              <li data-id="element-91">
                <a href="#ayuda" className="text-blue-100 hover:text-white transition-colors" data-id="element-92">
                  Centro de ayuda
                </a>
              </li>
              <li data-id="element-93">
                <a href="#faq" className="text-blue-100 hover:text-white transition-colors" data-id="element-94">
                  Preguntas frecuentes
                </a>
              </li>
              <li data-id="element-95">
                <a href="mailto:info@megarevolution.com" className="text-blue-100 hover:text-white transition-colors" data-id="element-96">
                  info@megarevolution.com
                </a>
              </li>
              <li data-id="element-97">
                <a href="tel:+1234567890" className="text-blue-100 hover:text-white transition-colors" data-id="element-98">
                  +1 (234) 567-890
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div data-id="element-99">
            <h3 className="text-xl font-bold mb-4" data-id="element-100">Newsletter</h3>
            <p className="text-blue-100 mb-4" data-id="element-101">
              Recibe ofertas exclusivas y novedades
            </p>
            <div className="flex flex-col gap-3" data-id="element-102">
              <input type="email" placeholder="Tu email" className="px-4 py-2 rounded-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-red-500" aria-label="Email para newsletter" data-id="element-103" />
              <Button variant="primary" className="w-full" data-id="element-104">
                Suscribirse
              </Button>
            </div>
          </div>
        </div>

        {/* Social Media & Copyright */}
        <div className="pt-8 border-t border-blue-800" data-id="element-105">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-106">
            <div className="text-blue-100" data-id="element-107">
              © 2026 Mega Revolution. Todos los derechos reservados.
            </div>

            <div className="flex gap-4" data-id="element-108">
              <a href="#facebook" className="p-2 bg-blue-800 hover:bg-blue-700 rounded-full transition-colors" aria-label="Facebook" data-id="element-109">
                <FacebookIcon className="h-5 w-5" data-id="element-110" />
              </a>
              <a href="#instagram" className="p-2 bg-blue-800 hover:bg-blue-700 rounded-full transition-colors" aria-label="Instagram" data-id="element-111">
                <InstagramIcon className="h-5 w-5" data-id="element-112" />
              </a>
              <a href="#twitter" className="p-2 bg-blue-800 hover:bg-blue-700 rounded-full transition-colors" aria-label="Twitter" data-id="element-113">
                <TwitterIcon className="h-5 w-5" data-id="element-114" />
              </a>
              <a href="mailto:info@megarevolution.com" className="p-2 bg-blue-800 hover:bg-blue-700 rounded-full transition-colors" aria-label="Email" data-id="element-115">
                <MailIcon className="h-5 w-5" data-id="element-116" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}